export default __webpack_public_path__ + "static/media/crop.9fe8278b.svg";